module.exports = __webpack_public_path__ + "static/media/texture-season-6.5848b56c.jpg";